import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-600" }, " Medikamenteninformationen werden geladen ", -1)
const _hoisted_3 = {
  key: 1,
  class: "text-sm text-red"
}
const _hoisted_4 = {
  key: 2,
  class: "text-sm text-red"
}
const _hoisted_5 = {
  key: 3,
  class: "text-sm text-gray-600"
}

import { BaseMedication } from "@/interfaces/medication";
import { computed } from "vue";
import NincdString from "./NincdString.vue";
import PharmacodeString from "./PharmacodeString.vue";
import GtinString from "./GtinString.vue";
import PublicPriceString from "./PublicPriceString.vue";
import StorageQuantityString from "./StorageQuantityString.vue";
import LoadingSpinner from "./LoadingSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MedicationInformation',
  props: {
    medication: {},
    asList: { type: Boolean },
    isLoading: { type: Boolean },
    error: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const dynamicClasses = computed(() => {
  return { block: props.asList };
});

const delimiter = computed(() => {
  return props.asList ? "" : "|";
});

return (_ctx: any,_cache: any) => {
  return (props.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(LoadingSpinner, { class: "!w-4" }),
        _hoisted_2
      ]))
    : (props.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "Fehler beim Laden der Medikamenteninformationen"))
      : (!props.medication?.isInIndex)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Dieses Medikament ist nicht mehr verfügbar."))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _createVNode(PharmacodeString, {
              pharmacode: props.medication?.pharmacode,
              long: true,
              class: _normalizeClass(dynamicClasses.value)
            }, null, 8, ["pharmacode", "class"]),
            _createTextVNode(" " + _toDisplayString(delimiter.value) + " ", 1),
            _createVNode(GtinString, {
              gtin: props.medication?.gtin,
              long: true,
              class: _normalizeClass(dynamicClasses.value)
            }, null, 8, ["gtin", "class"]),
            _createTextVNode(" " + _toDisplayString(delimiter.value) + " ", 1),
            _createVNode(NincdString, {
              nincd: props.medication?.nincd,
              long: true,
              class: _normalizeClass(dynamicClasses.value)
            }, null, 8, ["nincd", "class"]),
            _createTextVNode(" " + _toDisplayString(delimiter.value) + " ", 1),
            _createVNode(PublicPriceString, {
              "public-price": props.medication?.public_price,
              long: true,
              class: _normalizeClass(dynamicClasses.value)
            }, null, 8, ["public-price", "class"]),
            _createTextVNode(" " + _toDisplayString(delimiter.value) + " ", 1),
            _createVNode(StorageQuantityString, {
              "storage-quantity": props.medication?.storage_quantity,
              long: true,
              class: _normalizeClass(dynamicClasses.value)
            }, null, 8, ["storage-quantity", "class"])
          ]))
}
}

})